import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"printerListWindow"},[_c('div',{staticClass:"header"},[_c('div',[_vm._t("header")],2),_c('div',[_c(VBtn,{staticClass:"iconBtn",attrs:{"icon":""},on:{"click":_vm.close}},[_c(VIcon,{staticClass:"icon"},[_vm._v("mdi-close")])],1)],1)]),_c('div',{staticClass:"main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }